<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
      if(sessionStorage.getItem("partnerid")){
        this.$store.state.partnerid=sessionStorage.getItem("partnerid");
      }else if(sessionStorage.getItem("channel_id")){
        this.$store.state.partnerid=sessionStorage.getItem("channel_id");
      }else{
        this.$store.state.partnerid=0
      }
  }
}
</script>

<style lang='scss'>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 52px;
}

.active:after{
    display: block;
  }
  .swiper-pagination-bullet-active{
  opacity: 1;
  background: #E1251B !important;
}
button{display: none}
 .el-carousel__item {
    &:not(.is-active){
      height: vp(200);
      margin-top: 0;
      margin-top: vp(66);
    }
    .is-active{
        height: vp(20) !important;
        transform: translateX(293px) scale(0.5) !important;
      }
  }
  #banner{
    .swiper-pagination-bullet-active{
      width:vp(20) !important;
      border-radius:vp(6);
      height:vp(10) !important;
      background:white !important;
    }
  }
  .pagination-pc{
    .swiper-pagination-bullet-active{
      width:vp(15) !important;
      border-radius:50% !important;
      height:vp(15) !important;
      background:white !important;
    }
  }
  .pagination-mob{
    .swiper-pagination-bullet{
      width:vt(8) !important;
      border-radius:50% !important;
      height:vt(8) !important;
    }
    .swiper-pagination-bullet-active{
      width:vt(10) !important;
      border-radius:50% !important;
      height:vt(10) !important;
      background:white !important;
    }
  }
  #teshuWhite{
    .swiper-pagination-bullet{
      width:vt(6);
      height:vt(6);
    }
    .swiper-pagination-bullet-active{
      width:vt(12) !important;
      border-radius:vt(6);
      height:vt(6) !important;
      background:white !important;
    }
  }
  .swiper-pagination-bullet{
    margin-left:vp(6) !important;
  }
  .ql-align-center {
  text-align: center;
}
.content-text .ql-align-center{
  text-align: center;
}
@media screen and (min-width: 998px) {
    .contentContainer{
      .content{
          img{
          width: auto;  
          height: auto;  
          max-width: 100%;  
          max-height: 100%; 
        }
      }
  }
}
@media screen and (max-width: 998px) {
  #teshuWhite{
    .swiper-pagination{
      bottom: vt(30)
    }
  }
  // img{width:vt(330)};
  .content-text .ql-align-center,.ql-align-justify{
  text-align: left;

  }
  .ql-align-justify.ql-video{
    display: flex;
    margin: 0 auto;
  }
  .ql-align-center,.ql-align-justify,.ql-video{
    width: auto;  
    height: auto;  
    max-width: vt(361);
    max-height: 100%;
    img{
    width: auto;  
    height: auto;  
    max-width: vt(361);
    max-height: 100%; 
  }
  }
  .content{
    .content-text{
      img{
      width: auto;  
      height: auto;  
      max-width: 100%;  
      max-height: 100%; 
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/App.vue